<template>
  <div class="GlobalTable">
    <div class="button_top">
      <div>
        <span style="margin-right: 10px;">
          最新通知时间：{{ noticeTime|| "- -" }}</span>
        <span style="margin-right: 10px;">
          最新查询时间：{{ selectTime|| "- -" }}</span>
        <!-- <el-button size="small" type="warning" @click="searchRecord">手动查询记录</el-button> -->
        <el-button size="small" type="primary" @click="putBlacklist">手动查询</el-button>
        <el-button size="small" type="success" @click="clickExcel">导出excel</el-button>
      </div>
    </div>
    <div style="    margin-bottom: 10px;
    color: rgb(255, 104, 123);font-size: 14px;">
      充值记录分为两种方式通知：到账时主动通知和主动查询；系统将每5分钟查询一次当日记录，凌晨12点时查询昨日记录</div>
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="交易流水号" slot="bizType" align="center" width="150px">
        <template slot-scope="{ row }">
          <span>{{ row.outUniqNo || "- -"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收款银行" slot="relationNo" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.payeeBankOpening || "- -" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="收款账号" slot="bankAccount" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.payeeBankCard || "- -" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="付款账号" slot="payAccount" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.payerBankCard || "- -" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="交易信息来源" slot="getWay" align="center" width="150px">
        <template slot-scope="{ row }">
          <div v-if="row.getWay == '00'">主动查询</div>
          <div v-if="row.getWay == '01'">微众通知</div>
        </template>
      </el-table-column>
      <el-table-column label="商户类型" slot="accountType" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.accountType == 'merchant'">回收商</div>
          <div v-if="row.accountType == 'company'">门店商</div>
        </template>
      </el-table-column>
      <el-table-column label="自动上账情况" slot="autoRunFailNote" align="center" width="150">
        <template slot-scope="{ row }">
          <span>{{ row.autoRunFailNote }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="handleBtn(row)"
            v-if="row.autoRunFailNote !== '重新上账成功'">重新上账</el-button>
        </template>
      </el-table-column>
    </GlobalTable>
    <!--手动查询确认-->
    <el-dialog title='手动查询确认' :visible.sync="commandShow" :close-on-click-modal="false" width="600px"
      @closed="commonclose">
      <div class="enable-tip">
        <div>查询后，需等待查询完毕后才可继续查询，是否确认查询？
        </div>
      </div>
      <div class="command">
        <div style="width: 85px;">动态口令：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="commonclose">取消</el-button>
        <el-button type="primary" :loading="butLoading" @click.native="renewSubmit">确认查询</el-button>
      </span>
    </el-dialog>
    <!--导出弹框-->
    <el-dialog title="操作提示" :visible.sync="codeShow" :close-on-click-modal="false" width="500px" @closed="code = ''">
      <div style="font-size: 14px;margin-bottom: 20px;">
        <div style="margin-top: 10px;color: #333333;font-size: 16px;text-align: center;">是否确认导出？</div>
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 10px;">
        <div style="width: 88px">动态口令：</div>
        <el-input v-model="code" placeholder="请输入谷歌动态口令"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="codeShow = false">取消</el-button>
        <el-button type="primary" :loading="isExport" @click.native="codeSubmit">确定</el-button>
      </span>
    </el-dialog>
    <!--手动查询记录-->
    <!-- <el-dialog title="手动查询记录" :visible.sync="recordShow" :close-on-click-modal="false" width="450px"
      @closed="recordClose" v-if="recordShow">
      <span slot="footer" class="dialog-footer">
        <GlobalForm ref="ruleform" :uploadLength="1" :init-data="initData" :form-rules="formRules"
          :form-item-list="formItemList" @handleConfirm="handleConfirm" confirmBtnName="确认提交" style="margin-top: 10px;"
          class="mycommandform">
          <el-form-item class="el_from" label="谷歌验证码" prop="cause" slot="cause">
            <el-input oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')" placeholder="请输入谷歌验证码"
              v-model="initData.cause" class="mycommand"></el-input>
          </el-form-item>
          <el-button slot="btnSlot" @click="recordClose">取消</el-button>
        </GlobalForm>
      </span>
    </el-dialog> -->
    <!--重新上账-->
    <el-dialog title="重新上账二次确认" :visible.sync="againShow" :close-on-click-modal="false" width="450px"
      @closed="againClose" v-if="againShow">

      <div style="margin-bottom: 10px;">上账商户：{{ obj.enterpriseName }}</div>
      <div style="margin-bottom: 10px;">金额：¥{{ obj.rechargeAmount }}({{ obj.rechargeAmount | formatChineseCurrency }})</div>
      <div style=" margin-bottom: 10px;
    color: rgb(255, 104, 123);font-size: 14px;text-align: center;">是否确认重新上账?</div>
      <GlobalForm ref="ruleform" :uploadLength="1" :init-data="initAgainData" :form-rules="formAgainRules"
        :form-item-list="formAgainItemList" @handleConfirm="handleAgainConfirm" confirmBtnName="确定"
        style="margin-top: 10px;" class="mycommandform1">
        <el-form-item class="el_from" label="谷歌验证码" prop="cause" slot="cause">
          <el-input oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')" placeholder="请输入谷歌验证码"
            v-model="initAgainData.cause" class="mycommand"></el-input>
        </el-form-item>
        <el-button slot="btnSlot" @click="againClose">取消</el-button>
      </GlobalForm>

    </el-dialog>
  </div>
</template>

<script>
import { _http } from "@/utils/request/rechargeRecord";
export default {
  name: "Table",
  props: {
    // accountType: {
    //   require: true,
    //   type: String
    // },
  },
  data() {
    return {
      isExport: false,
      sdcommShow: false,
      command: "",
      params: {},
      commandShow: false,
      loading: false,
      butLoading: false,
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      pageNum: 1,
      tableColumns: [
        { slotName: "bizType" },
        { label: "交易时间", prop: "rechargeTime" },
        { slotName: "relationNo" },
        { slotName: "bankAccount" },
        { label: "交易金额", prop: "rechargeAmount" },
        { label: "付款姓名", prop: "payerBankCardholder" },
        { slotName: "payAccount" },
        { label: "付款银行", prop: "payerBankOpening" },
        { label: "交易备注", prop: "rechargeNote" },
        { slotName: "getWay" },
        { label: "信息获取时间", prop: "createTime", width: "150px" },
        { slotName: "accountType" },
        { label: "上账商户", prop: "enterpriseName" },
        { label: "执行时间", prop: "autoRunTime" },
        { slotName: "autoRunFailNote" },
        { slotName: "operation" }
      ],
      // 弹出框
      bizType: "",
      codeShow: false,
      code: "",
      obj: {},//上账对象,
      // recordShow: false,
      // initData: {
      //   cause: "",
      // },
      initAgainData: {
        cause: "",
      },
      formAgainRules: {
        cause: [
          {
            required: true,
            trigger: "blur",
            message: "请输入谷歌验证码",
          },
        ],
      },
      formAgainItemList: [
        { slotName: "cause" },
      ],
      formRules: {
        cause: [
          {
            required: true,
            trigger: "blur",
            message: "请输入谷歌验证码",
          },
        ],
      },
      formItemList: [
        { slotName: "cause" },
      ],
      againShow: false,
      noticeTime: "",
      selectTime: "",
    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams
    },
  },
  mounted() {
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal)
      this.page.pageNum = 1
      this.handleCurrentChange()
    },
  },
  methods: {

    //关闭动态口令
    commonclose() {
      this.commandShow = false;
      this.command = ''
    },
    //手动查询
    putBlacklist() {
      this.commandShow = true
    },
    //手动查询确认
    renewSubmit() {
      //未识别
      if (!this.command) {
        return this.$message.error("请输入动态口令");
      }
      // this.params.command = this.command
      // _api.joinBlacklist(this.params).then(res => {
      //   if (res.code == 1) {
      //     this.sdcommShow = false
      //     this.commandShow = false
      //     this.$message({
      //       message: '手动查询成功！',
      //       type: 'success'
      //     });
      //     this.handleCurrentChange()
      //   }
      // })
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log(this.SeachParams, "SeachParams00000")
      this.$emit('params', this.SeachParams)
      if (!this.SeachParams.startTime) {
        if (typeof this.SeachParams.disuseLoding == "function") {
          this.SeachParams.disuseLoding();
        }
        return this.$message.error("请选择交易时间")
      }
      // if (!this.SeachParams.startTimeInfo) {
      //   if (typeof this.SeachParams.disuseLoding == "function") {
      //     this.SeachParams.disuseLoding();
      //   }
      //   return this.$message.error("请选择信息获取时间")
      // }
      if (val) {
        this.pageNum = val
        this.page.pageNum = val;
      }
      const baseRequest = {
        outUniqNo: this.SeachParams.transferNo,//交易流水号
        payerBankCardholder: this.SeachParams.relationNo,//付款姓名
        payerBankCard: this.SeachParams.staffName,//付款账号
        getWay: this.SeachParams.staffRole,//交流信息来源
        payeeBankCard: this.SeachParams.bankAccount,//收款账号
        upState: "00",//待上账 01上账
        identifyState: "01",//未识别00 01已识别
        payeeBankOpening: this.SeachParams.bankName,//收款银行
        rechargeTimeStart: this.SeachParams.startTime,//交易开始时间
        rechargeTimeEnd: this.SeachParams.endTime,//交易结束时间
        createTimeStart: this.SeachParams.startTimeInfo,//信息获取时间开始
        createTimeEnd: this.SeachParams.endTimeInfo,//信息获取时间结束
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        accountType: this.SeachParams.merchantType,//商户选择
        enterpriseName: this.SeachParams.accountEntry,//上账商户
      };
      this.loading = true
      _http.getList(baseRequest).then(res => {
        if (res.code === 1) {
          this.seachDataList = res.data.list.records;
          this.page.total = res.data.list.total;
          this.page.pageNum = res.data.list.current;
          this.noticeTime = res.data.noticeTime
          this.selectTime = res.data.selectTime
          this.loading = false
        }
      }).finally(() => {
        if (typeof this.SeachParams.disuseLoding == "function") {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 弹出弹框
    handleBtn(row) {
      this.obj = row
      this.againShow = true
    },
    // 导出
    clickExcel() {
      this.codeShow = true
    },
    // 导出账单弹框确定
    codeSubmit() {
      //未识别
      if (!this.code.trim()) {
        return this.$message.error("请输入动态口令");
      }
      const params = {
        outUniqNo: this.SeachParams.transferNo,//交易流水号
        payerBankCardholder: this.SeachParams.relationNo,//付款姓名
        payerBankCard: this.SeachParams.staffName,//付款账号
        getWay: this.SeachParams.staffRole,//交流信息来源
        payeeBankCard: this.SeachParams.bankAccount,//收款账号
        upState: "00",//待上账 01上账
        identifyState: "01",//未识别00 01已识别
        payeeBankOpening: this.SeachParams.bankName,//收款银行
        rechargeTimeStart: this.SeachParams.startTime,//交易开始时间
        rechargeTimeEnd: this.SeachParams.endTime,//交易结束时间
        createTimeStart: this.SeachParams.startTimeInfo,//信息获取时间开始
        createTimeEnd: this.SeachParams.endTimeInfo,//信息获取时间结束
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        accountType: this.SeachParams.merchantType,//商户选择
        enterpriseName: this.SeachParams.accountEntry,//上账商户
      }
      this.isExport = true
      _http.excel(params).then(res => {
        console.log(res)
        // if (this.SeachParams.startTime) {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => { //
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || '导出失败')
            }
          } catch (err) {
            const fileName = "出账账单列表.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
            this.codeShow = false
          }
        })
        reader.readAsText(blob, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
        this.isExport = false
      }).catch(err => {
        this.isExport = false
        console.log(err)
      });
    },
    // //点击手动查询记录按钮
    // searchRecord() {
    //   this.recordShow = true
    // },
    // //关闭手动查询记录弹框
    // recordClose() {
    //   this.recordShow = false
    // },
    // //手动查询
    // handleConfirm() {

    // },
    //重新上账关闭
    againClose() {
      this.againShow = false
      this.initAgainData.caus=""
    },
    //重新上账确定
    handleAgainConfirm() {
      _http.reUp({accountRechargeRecordId:this.obj.id,command:this.initAgainData.cause}).then(res=>{
        if(res.code==1){
          this.againShow = false
          this.initAgainData.caus=""
          this.handleCurrentChange(1)
        }
      })

    },

  },
  filters: {
    formatChineseCurrency(num) {
      console.log(num,"num")
      if (num === 0) return "零元";

      const units = ["", "拾", "佰", "仟", "万", "拾", "佰", "仟", "亿", "拾", "佰", "仟", "万", "拾", "佰", "仟"];

      const nums = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];

      let result = "";

      let zero = true;

      // 处理整数部分

      let integerPart = Math.floor(num);

      for (let i = 0; i < units.length; i++) {

        let n = Math.floor(integerPart / Math.pow(10, units.length - i - 1)) % 10;

        if (n === 0) {

          if (!zero) {

            zero = true;

            result += nums[0];

          }

        } else {

          zero = false;

          result += nums[n] + units[units.length - i - 1];

        }

      }
      console.log(integerPart,"integerPart")
      console.log(result,"result")
      if(!result){
        result="零"
      }
      result = result.replace(/零+/g, "零").replace(/零+$/, "");

      result = result.replace(/零万/g, "万").replace(/零亿/g, "亿");

      if (result.startsWith("壹拾")) {

        result = result.substring(1);

      }

      // 处理小数部分

      let decimalPart = num - integerPart;
      console.log(decimalPart,"decimalPart")
      if (decimalPart > 0) {
        if(integerPart==0){
          result += "零元";
        }
        if(integerPart>0){
          result += "元";
        }
       

        let decimalStr = decimalPart.toFixed(2).split('.')[1];

        let hasJiao = false;

        for (let i = 0; i < decimalStr.length; i++) {

          let n = parseInt(decimalStr[i]);

          if (i === 0) { // 角

            if (n !== 0) {

              result += nums[n] + "角";

              hasJiao = true;

            } else {

              result += "零角";

            }

          } else if (i === 1) { // 分

            if (n !== 0) {

              result += nums[n] + "分";

            } else if (!hasJiao) {

              result += "零分";

            }

          }

        }

      } else {

        result += "元";

      }
      return result
    },
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  .qb_act {
    display: flex;
    margin: 10px 0;

    .qukliy_box {
      font-size: 13px;
      margin-right: 10px;
      line-height: 13px;
      border-radius: 5px;
      padding: 5px 10px;
      background-color: #e4ecfd;
      color: rgb(9, 129, 255);
    }
  }

  .generated {
    margin-left: -30px;
  }

  .ga_content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  // 备注说明
  .enable-tip {
    color: #FF8080;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .el_from {
    margin-left: -120px;
    margin-bottom: 0;
  }

  /deep/.el-select {
    width: 100% !important;
  }

  .command {
    display: flex;
    align-items: center;

    /deep/.el-input {
      width: 300px;
    }
  }

  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .openSytle {
    padding: 20px 10px;
    background-color: #F5F5F5;
  }

  .operation-btn {
    /deep/.el-button {
      margin-left: 0;
    }
  }

  .button_top {
    margin-bottom: 20px;
    ;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .faultBtn {
    width: 280px;
    height: 34px;
    background: #F9FBFD;
    border: 1px solid #C1D1FF;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    cursor: pointer;

    .active {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      background: #0981FF;
      border-radius: 20px;
    }

    .none {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      border-radius: 20px;
    }
  }

  .verify-title {
    color: #0981FF;
    line-height: 16px;
    font-size: 16px;
    padding-left: 10px;
    border-left: 3px solid;
    margin-bottom: 10px;
  }

  .repair_dialog {
    /deep/.el-dialog__body {
      padding: 0 20px 0 20px;
    }

    /deep/.el-loading-mask .el-loading-spinner {
      margin-top: -35px !important;
    }
  }

  .repair-conent {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .verify-mark {
    width: max-content;
    font-size: 12px;
    color: #fff;
    padding: 0 6px;
    background: #FF687B;
    border-radius: 10px 8px 8px 0px;
    margin-left: 10px;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .flex-ac {
    align-items: center;
    justify-content: flex-start;
  }
}

/deep/ .mycommandform1 .el-form-item:nth-child(2) {
  display: flex;
  justify-content: flex-end;
}

// /deep/.mycommandform .el-input {
//     width: 300px;
//   }</style>
